var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgetsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9580_70640)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9580_70640)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9.7156C7 8.17995 8.24489 6.93506 9.78054 6.93506C11.3162 6.93506 12.5611 8.17995 12.5611 9.7156C12.5611 11.2512 11.3162 12.4961 9.78054 12.4961C8.24489 12.4961 7 11.2512 7 9.7156Z",
    fill: "#C6CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4453 16.1551C13.4453 14.6194 14.6902 13.3745 16.2259 13.3745C17.7615 13.3745 19.0064 14.6194 19.0064 16.1551C19.0064 17.6907 17.7615 18.9356 16.2259 18.9356C14.6902 18.9356 13.4453 17.6907 13.4453 16.1551Z",
    fill: "#7B86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16.2347C7 14.9619 7 14.3255 7.39541 13.9301C7.79083 13.5347 8.42723 13.5347 9.70005 13.5347C10.9729 13.5347 11.6093 13.5347 12.0047 13.9301C12.4001 14.3255 12.4001 14.9619 12.4001 16.2347C12.4001 17.5075 12.4001 18.1439 12.0047 18.5394C11.6093 18.9348 10.9729 18.9348 9.70005 18.9348C8.42723 18.9348 7.79083 18.9348 7.39541 18.5394C7 18.1439 7 17.5075 7 16.2347Z",
    fill: "#7B86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 9.63511C13.5938 8.36229 13.5938 7.72588 13.9892 7.33047C14.3846 6.93506 15.021 6.93506 16.2938 6.93506C17.5666 6.93506 18.203 6.93506 18.5984 7.33047C18.9938 7.72588 18.9938 8.36229 18.9938 9.63511C18.9938 10.9079 18.9938 11.5443 18.5984 11.9397C18.203 12.3352 17.5666 12.3352 16.2938 12.3352C15.021 12.3352 14.3846 12.3352 13.9892 11.9397C13.5938 11.5443 13.5938 10.9079 13.5938 9.63511Z",
    fill: "#C6CAD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9580_70640",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9580_70640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9580_70640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9580_70640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7 6.93506)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsIcon);
export default __webpack_public_path__ + "static/media/WidgetsIcon.264947d1cba32ec788ee232ca176d1b1.svg";
export { ForwardRef as ReactComponent };